import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { UserApiService } from '../../services/user-api.service';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { Guid } from 'guid-typescript';
import { FormControl, FormGroup } from '@angular/forms';
import { catchError, debounceTime, forkJoin, of } from 'rxjs';
import {
  BuyImportRequestDrugModal,
  BuyImportRequestModal,
} from '../../models/buy-import-modal';
import { BuyPreInvoiceImportRequestModal } from '../../models/buy-pre-invoice-import-modal';
import { ModalConfirm } from '../../models/modal-confirm';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { NewCalendarService } from 'src/app/services/new-calender-service';

@Component({
  selector: 'app-buy-pre-invoice',
  templateUrl: './buy-pre-invoice.component.html',
  styleUrls: ['./buy-pre-invoice.component.css'],
})
export class BuyPreInvoiceComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    private calendarService:NewCalendarService,
    public datepipe: DatePipe,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.getCompany();
    this.getSearchEntity();
    this.getEntity();
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'Delete' && this.tableElement.focusRow >= 0) {
        this.modalDeleteConfirm = true;
        this.thisValue = this.data?.data[this.tableElement.focusRow];
      }
    });

    this.editableItem = new BuyImportRequestDrugModal(this.calendarService.GetNow());
    this.searchRequestModel = new PCSearchRequestModel();
    this.backendJson = new BuyPreInvoiceImportRequestModal();
    this.requestModel = new PCSearchRequestModel();
    this.requestListModel = new PCSearchRequestModel();

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'List',
          className: 'btn-outline-primary',
          icon: 'bx bx-list-check',
        },
        {
          name: 'DeleteAll',
          className: 'btn-outline-danger',
          icon: 'bx bx-trash',
        },
      ],
      'BuyPreInvoice',
      []
    );

    this.actionList = new PCTableActionInputModel(
      [
        {
          name: 'ReloadList',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Add',
          className: 'btn-outline-primary',
          icon: 'bx bx-plus',
        },
      ],
      'BuyPreInvoice',
      []
    );

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });
  }

  public editableItem: BuyImportRequestDrugModal;
  public searchData: any;
  public searchPaging: any;
  public endPoint: string = `BuyPreInvoice/SuggestionItems`;
  public data?: PCTableInputModel;
  public listData?: PCTableInputModel;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public actionList: PCTableActionInputModel;
  public fields: any[] = [];
  public searchLoading: boolean = false;
  public openAddModal: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public modalIsOpen: boolean = false;
  public searchRequestModel: PCSearchRequestModel;
  public breadCrumb: string = '';
  public drugSearchForm: FormGroup;
  public backendJson: BuyPreInvoiceImportRequestModal;
  public companyList: any[] = [];
  public sellerList: any[] = [];
  public level: number = 1;
  public searchFields: any[] = [];
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;

  public modalConfirm: ModalConfirm = new ModalConfirm();

  public requestModel: PCSearchRequestModel;
  public requestListModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public thisValue: any;

  public monthName: string = '';

  public activeSerch: boolean = true;
  @ViewChild('ShowTable') tableElement!: PCTableComponent;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;

  public companyDropDown: DropDownPagingInput = new DropDownPagingInput(
    'drugDistributor',
    'title',
    'title',
    false,
    true,
    true,
    true,
    false
  );

  public ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSerch) {
          this.searchDrug(value);
        } else {
          this.activeSerch = true;
        }
      });

    if (this.endPoint == null) {
      this.logger.addError('Endpoint is required .....!!!', false);
      return;
    }

    this.backendJson.preInvoiceDate = new Date().toISOString();
    this.generateUrl();
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'BuyPreInvoice',
          null,
          undefined,
          'BuyPreInvoice',
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.fields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }

            this.data = new PCTableInputModel(
              [],
              [
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                },
              ],
              true,
              1,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            setTimeout(() => {
              this.pcTableComponent.InitPage();
            }, 2);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public geToSingletData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService
        .getWitoutPage(new ApiRequestModel(this.endPointUrl))
        .subscribe(
          (result) => {
            this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
            if (result.succeeded) {
              this.data = new PCTableInputModel(
                result.data?.map((current) => ({
                  id: current.drugId,
                  persianName: current.drugPersianName,
                  drugName: current.drugName,
                  count: 0,
                  inlineEditState: true,
                })),
                [
                  {
                    name: 'Delete',
                    className: 'btn-outline-danger',
                    icon: 'bx bx-trash',
                  },
                ],
                true,
                1,
                this.requestModel.orderBy,
                this.requestModel.direction
              );

              setTimeout(() => {
                let selectStockPage =
                  document.getElementById('selectStockPage');
                if (selectStockPage) {
                  selectStockPage.classList.remove('animate__backInDown');
                }
              }, 2 * 1000);
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }

    setTimeout(() => {}, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  private getListElements(url, item, fieldName) {
    this.apiService.getAll(new ApiRequestModel(`${url}`)).subscribe(
      (result) => {
        this.logger.addResponseLog(url == null ? '' : url, result, `getAll`);
        if (result.succeeded) {
          if (fieldName == undefined) {
            item.dropDownValue = result.data?.items.map((current) => ({
              id: current.id,
              friendlyName: current.persianName,
            }));
          } else {
            item.dropDownValue = result.data?.items.map((current) => ({
              id: current.id,
              friendlyName: current[fieldName],
            }));
          }
        } else {
          this.logger.addBackEndMessage(result);
        }
      },
      (error) => {
        this.apiService.AddErrorLog(error);
      },
      () => {}
    );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=1&pageSize=1000&paging=false&orderBy=ExpierDate&direction=asc&search=${this.requestModel.search}`;
  }

  public submitDelete() {
    try {
      const index = this.data?.data.findIndex(
        (current) => current.id == this.thisValue.id
      );
      this.data?.data.splice(index, 1);
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public deleteAll() {
    this.data?.data.splice(0);
  }

  public createJson(inputElement) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];
      let exactMatch = new RegExp(`ArrayList`);
      if (element.fieldDatatype.match(exactMatch) != null) {
        backentJson[element.fieldName] = [];
        if (typeof element.defValue == 'string') {
          backentJson[element.fieldName].push(element.defValue);
        } else if (element.defValue instanceof Array) {
          for (let index = 0; index < element.defValue.length; index++) {
            const defelement = element.defValue[index];
            backentJson[element.fieldName].push(defelement);
          }
        }

        continue;
      }

      exactMatch = new RegExp(`Enum`);
      if (
        element.fieldDatatype.match(exactMatch) != null &&
        element.defValue == ``
      ) {
        backentJson[element.fieldName] = null;
        continue;
      }

      if (element.defValue != null && typeof element.defValue == 'string') {
        exactMatch = new RegExp(`double`);
        if (element.defValue.match(exactMatch) != null) {
          backentJson[element.fieldName] = 0;
          continue;
        }
      }

      if (element.defValue == null && element.fieldDatatype == 'boolean') {
        backentJson[element.fieldName] = false;
        continue;
      }

      if (element.fieldDatatype == 'TimeSpan') {
        backentJson[element.fieldName] = this.changeTime(element.defValue);
        continue;
      }

      backentJson[element.fieldName] = element.defValue;
    }

    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.geToSingletData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.geToSingletData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.geToSingletData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.geToSingletData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.geToSingletData();
        break;
      case 'Close':
        this.thisValue = undefined;
        this.openAddModal = false;
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        break;
      case 'NotDelete':
        this.modalDeleteConfirm = false;
        this.thisValue = undefined;
        break;
      case 'ConfirmDelete':
        this.modalDeleteConfirm = false;
        this.submitDelete();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'DeleteAll':
        this.deleteAll();
        break;
      case 'List':
        this.goToListPage('AddCard');
        break;
      case 'Add':
        this.goToAddPage('listCard');
        break;
      case 'ReloadList':
        this.loading = true;
        this.generateListUrl();
        this.getListData();
        break;
      default:
        break;
    }
  }

  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  public addNewRow(item: any) {
    this.data?.data.push({
      id: item.id,
      persianName: item.drugBrandPersianName,
      drugName: item.drugBrandName,
      count: 0,
      inlineEditState: false,
    });
    this.modalIsOpen = false;
  }

  public parentSearchAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.searchLoading = true;
        if (this.searchRequestModel.orderBy == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.orderBy != event.data) {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == '') {
          this.searchRequestModel.direction = 'asd';
        } else if (this.searchRequestModel.direction == 'asd') {
          this.searchRequestModel.direction = 'desc';
        }

        this.searchRequestModel.orderBy = event.data;

        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'Paging':
        this.searchLoading = true;

        this.searchRequestModel.pageNumber = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'PageSize':
        this.searchLoading = true;
        this.searchRequestModel.pageSize = event.data;
        this.searchDrug(this.editableItem.drugName!);
        break;
      case 'SelectItem':
        this.addNewRow(event.data);
        break;
      default:
        break;
    }
  }

  public generateSearchUrl(drugName: string): string {
    return `BuyFactor/AdvanceSearch?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${drugName}`;
  }

  public searchDrug(drugName: string): void {
    try {
      this.searchLoading = true;

      if (!drugName) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      const regexBarcode: RegExp =
        /^01(?<GTN>\d{14})21(?<UID>\d{20})17(?<exp>\d{6,8})10(?<lot>.*)$/;
      if (regexBarcode.test(drugName)) {
        const groups = drugName.match(regexBarcode)?.groups;
        this.editableItem.lot = String(groups?.['lot']);

        const expireDate: string = String(groups?.['exp']);

        const regexExpDate: RegExp = /(?<year>\d{2})(?<month>\d{2})/;
        if (regexExpDate.test(expireDate)) {
          const expiregroups = expireDate.match(regexExpDate)?.groups;

          const year: number = Number(expiregroups?.['year']);
          const month: string = String(expiregroups?.['month']);

          this.editableItem.expireDate = `20${year}-${month}-29 12:00:00`;
        }
      }
      let url = this.generateSearchUrl(drugName);

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);

            setTimeout(() => {
              if (this.searchBoxComponent) {
                this.searchBoxComponent.InitPage();
              } else {
                console.error('PCTableComponent not found');
              }
            }, 2);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.searchLoading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.searchLoading = false;
    }
  }

  public changeCompany(event) {
    if (event.id) {
      this.backendJson.companyId = event.id;
      this.getSeller(this.backendJson.companyId!);
    }
    this.validateForm();
  }

  public changeSeller(event) {
    if (event.id) {
      this.backendJson.sellerId = event.id;
    }
    this.validateForm();
  }

  public factorTypeDate() {
    this.backendJson.preInvoiceDate = this.TypeDate('factorDate');
    this.validateForm();
  }

  public TypeDate(elementId: string): string {
    const expiteValue = (<HTMLInputElement>(
      document.getElementById(`${elementId}`)
    )).value;

    const yearDatePattern: RegExp = /^(?<year>\d{4})$/;

    const testyearDatePattern: boolean = yearDatePattern.test(expiteValue);
    if (testyearDatePattern) {
      return `${expiteValue}/`;
    }

    const monthDatePattern: RegExp = /^(?<year>\d{4})(\/{1})(?<month>\d{2})$/;

    const testmonthDatePattern: boolean = monthDatePattern.test(expiteValue);
    if (testmonthDatePattern) {
      const groups = expiteValue.match(monthDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      return `${year}/${monthString}/`;
    }

    const fullDatePattern: RegExp =
      /^(?<year>\d{4})(\/{1})(?<month>\d{1,2})(\/{1})(?<day>\d{1,})/;
    const testfullDatePattern: boolean = fullDatePattern.test(expiteValue);
    if (testfullDatePattern) {
      const groups = expiteValue.match(fullDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);
      const day: number = Number(groups?.['day']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      let dayString = day.toString();
      if (day < 10) {
        dayString = dayString.padStart(2, '0');
      } else if (day > 31) {
        dayString = '30';
      }

      return `${year}-${monthString}-${dayString}T12:00:00`;
    }

    return expiteValue;
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public deliveryTypeDate() {
    this.backendJson.receiveDate = this.TypeDate('RecivedDate');
    this.validateForm();
  }

  public getSeller(companyId: string) {
    try {
      this.loading = true;
      let url = `Seller/SpecificCompany/${companyId}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.sellerList = [];
          }
          if (result.succeeded) {
            if (result.data) {
              this.sellerList = result.data.map((current) => ({
                id: current.id,
                name:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                      ' ' +
                      current.lastName +
                      ' - ' +
                      current.mobileNumber,
                persianName:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                      ' ' +
                      current.lastName +
                      ' - ' +
                      current.mobileNumber,
              }));
            } else {
              this.sellerList = [];
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getSearchEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'BuyPreInvoice',
          null,
          undefined,
          'BuyPreInvoice',
          `DrugSearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `Get Entity`
          );
          if (result.succeeded) {
            this.searchFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public getCompany() {
    try {
      this.loading = true;
      let url = `DrugDistributor?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.companyList = [];
          }
          if (result.succeeded) {
            this.companyList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.title,
              persianName: current.title,
              companyTypeId: current.companyTypeId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public clearForm() {
    this.backendJson = new BuyPreInvoiceImportRequestModal();
  }

  public validateForm(): boolean {
    let isValidate = true;
    if (!this.backendJson.companyId) {
      this.backendJson.companyIdMessage = `این فیلد اجباری است`;
      isValidate = false;
    } else {
      this.backendJson.companyIdMessage = undefined;
    }

    if (!this.backendJson.preInvoiceDate) {
      this.backendJson.preInvoiceDateMessage = `این فیلد اجباری است`;
      isValidate = false;
    } else {
      this.backendJson.preInvoiceDateMessage = undefined;
    }

    if (
      this.thisValue.creatorCompanyId == null ||
      this.thisValue.creatorCompanyId ==
        '00000000-0000-0000-0000-000000000000' ||
      this.thisValue.creatorCompanyId == ''
    ) {
      this.companyDropDown.buttonClass = 'is-invalid';
      this.thisValue.creatorCompanyHint = `این فیلد اجباری است`;
    } else {
      this.thisValue.creatorCompanyHint = undefined;
    }

    if (this.data?.data == null || this.data.data.length == 0) {
      this.logger.addError(
        `پیش فاکتور نیاز به ثبت حداقل یک مورد را دارد`,
        false
      );
      isValidate = false;
    }

    return isValidate;
  }

  public submitForm() {
    try {
      if (!this.validateForm()) {
        return;
      }

      this.backendJson.drugs = this.data?.data.map((current) => ({
        drugId: current.id,
        count: current.count,
        drugName: current.drugName,
      }));

      this.loading = true;

      let url = `BuyPreInvoice/BuyImport`;
      console.log(this.backendJson);
      // this.backendJson.companyId='e97632d6-6207-40b5-883f-a8c129823cc2';
      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalSuccessConfirm = true;
              //this.backendJson.totalPrice = result.data.finalPayment;
              //this.factorId = result.data.factorId;
              //this.barcode = result.data.barcode;
              //this.dateTime = result.dateTime;
              //this.finalDrugList = result.data.prescriptions;
              //this.companyId = result.data.companyId;
              //this.isfactor = true;
              //this.goToListPage('addCard');
            } else {
              this.logger.addBackEndMessage(result);
            }

            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public goToListPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 2;
    }, 700);

    this.loading = true;
    this.generateListUrl();
    this.getListData();
  }

  public goToAddPage(cardId: string) {
    let selectStockPage = document.getElementById(cardId);
    if (selectStockPage) {
      selectStockPage.classList.add('animate__backOutDown');
    }

    setTimeout(() => {
      this.level = 1;
    }, 700);

    this.loading = true;
    this.generateUrl();
    this.geToSingletData();
  }

  public getListData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount != 0 &&
              result.data?.pageCount! < result.data?.pageNumber!
            ) {
              this.requestModel.pageNumber = 1;
            }

            this.listData = new PCTableInputModel(
              result.data?.items.map((current) => ({
                id: current.id,
                companyName: current.companyName,
                preInvoiceDate: current.preInvoiceDate,
                description: current.description,
                preInvoiceId: current.preInvoiceId,
                receiveDate: current.receiveDate,
                sellerId: current.sellerId,
              })),
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }

    setTimeout(() => {}, 700);

    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public generateListUrl() {
    this.endPointUrl = `BuyPreInvoice?pageNumber=${this.requestListModel.pageNumber}&pageSize=${this.requestListModel.pageSize}&paging=true&orderBy=${this.requestListModel.orderBy}&direction=${this.requestListModel.direction}&search=${this.requestListModel.search}`;
  }
}
